import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RHelpChatConfigDirty = t.readonly(
  t.type({
    isEnabled: t.boolean,
    chatId: t.string,
    userHash: t.string,
  }),
);

/*
 * Type.
 */

export interface HelpChatConfigModel extends t.TypeOf<typeof RHelpChatConfigDirty> {}
export const RHelpChatConfig = t.clean<HelpChatConfigModel>(RHelpChatConfigDirty as any);

/*
 * IO methods.
 */

export function parseHelpChatConfigModel(src: any): HelpChatConfigModel {
  return {
    isEnabled: src.enabled,
    chatId: src.chat_id,
    userHash: src.user_hash,
  };
}

/*
 * API type.
 */

export const ApiHelpChatConfig = makeApiType(
  'helpChatConfigModel',
  RHelpChatConfig,
  parseHelpChatConfigModel,
);
